import React from 'react';
import { MemoryRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import styled from 'styled-components';

import Header from './header/Header';
import Nav from './nav/Nav';
import Content from './content/Content';
import Footer from './footer/Footer';

const Overlay = styled.div`
    background-color: rgba(0, 0, 0, 0.5);
    position: fixed;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
    z-index: 99999999999999991;

    display: flex;
    align-items: center;
    justify-content: center;
`;

const GdprContainer = styled.div`
    background-color: ${props => props.theme.container.backgroundColor};
    font-family: 'Ubuntu', sans-serif !important;
    color: #777777;
    max-width: 800px;
    width: 100%;
    z-index: 99999999999999992;
`;

const mapStateToProps = state => ({ visible: state.visible });

const Gdpr = ({ visible }) => {
  return (
    <MemoryRouter>
      <Overlay style={{ display: visible ? 'flex' : 'none' }}>
        <GdprContainer>
          <Header></Header>
          <Nav></Nav>
          <Content></Content>
          <Footer></Footer>
        </GdprContainer>
      </Overlay>
    </MemoryRouter>
  )
};

export default connect(mapStateToProps)(Gdpr);